import { render, staticRenderFns } from "./DeletedClubDetail.vue?vue&type=template&id=bbfd52e6&scoped=true"
var script = {}
import style0 from "./DeletedClubDetail.vue?vue&type=style&index=0&id=bbfd52e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfd52e6",
  null
  
)

export default component.exports